( function( window, document, undefined ) {
  "use strict";

  let $ = window.jQuery,
	  tabboxes = $( '.most-everything__tabbox.pre-init' );

  /**
	  * Check how to initialize - directly or handled by event listener.
	  */
  function pre_init() {

    // Do the stuff only when box ist already there and wasn't initialized, yet.
    if ( tabboxes.length > 0 ) {

      init();

    } else  { // otherwise wait for newPage event and check again

      // Initialize event listener for lazy widget toppages.
      window.addEventListener('newPage', event_handled_init, false);
    }
  }

  /**
	 * Initialization handled by event listener for newPage event.
	 */
  function event_handled_init() {

    tabboxes = $( '.most-everything__tabbox.pre-init' );

    // Do the stuff only when box ist already there and wasn't initialized, yet.
    if ( tabboxes.length > 0 ) {

      init();

      // Remove current init function from newPage event.
      window.removeEventListener( 'newPage', event_handled_init, false );
    }
  }

  /**
	 * Inititalization: Fetch chartbeat data and init handlers for tab box.
	 */
  function init() {

    let cbContent = $('#vodl-cb-toppages[data-host][data-apikey][data-limit][data-refresh][data-filter]');

    if ( cbContent.length > 0 ) {
      toppages_init("vodl-cb-toppages", cbContent.data("host"), cbContent.data("apikey"), cbContent.data("limit"), cbContent.data("refresh"), cbContent.data("filter"));
    }

    initEventHandlers();

    tabboxes.removeClass( 'pre-init' );

  }

  /**
	  * Assigns click event handlers to all tabs in the tabboxes found on the page
	  */
  function initEventHandlers() {

	  //iterate over all tabboxes on the page
	  tabboxes.each( function() {

      var currentTabbox = $( this );

      //find all tabs inside the currentTabbox and assing click handler to each
      currentTabbox.find( ".most-everything__tabs div" ).each( function() {

        var tab = $( this );                    //the current tab li element
        var tabAnchor = $( this ).find( "a" );  //the anchor element inside the tab

        //just assign an event handler if the data-toggle attribute is set to "tab"
        if ( tabAnchor.data( "toggle" ) === "tab" ) {
          tab.off( "click" ).on( "click", function( e ) { handleTabClick( $( this ), currentTabbox, e ); } );
        }

      });

	  });
  }

  /**
	  * Handles a click on a tab
	  *
	  * @param {jQuery object} tab - the jQuery object of the clicked tab li element
	  * @param {jQuery object} currentTabbox - the jQuery object of the current tabbox
	  * @param {Event} e - the event object
	  */
  function handleTabClick( tab, currentTabbox, e ) {

	  e.preventDefault();

    var tabAnchor = tab.find( "a" ),                //the link element inside the clicked tab
      tabs = currentTabbox.find( ".most-everything__tabs div" ),    //all tabs in the current tabbox
      panes = currentTabbox.find( ".most-everything__tab-pane" ),  //all panes in the current tabbox
      paneSelector = false;

    //return if this tab is already active
    if ( tab.hasClass( "active" ) ) {
      return;
    }

	  //set all tabs and panes inactive
	  tabs.removeClass( "active" );
	  panes.removeClass( "active" );

	  //build/clean the selector for the new pane
	  paneSelector = tabAnchor.attr( "href" );
	  paneSelector = paneSelector && paneSelector.replace(/.*(?=#[^\s]*$)/, '');

	  //make the clicked tab and the corresponding pane active
	  tab.addClass( "active" );
	  currentTabbox.find( paneSelector ).addClass( "active" );

  }

  pre_init();

} )( window, document );
